var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 200,
    viewBox: "0 0 375 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2300_106344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 200
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V183.741C375 192.721 367.721 200 358.741 200H16.2592C7.27949 200 0 192.721 0 183.741V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2300_106344)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_2300_106344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.323 94.1248C215.776 216.672 181.851 365.493 124.403 308.044C66.9551 250.596 119.729 104.681 242.276 -17.8665C364.824 -140.414 510.739 -193.187 568.187 -135.739C625.635 -78.2911 460.871 -28.4228 338.323 94.1248Z",
    fill: "#896BFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_2300_106344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8557 -37.9238C-45.6919 84.6237 -79.7122 233.348 -137.064 175.996C-194.416 118.644 -141.564 -27.1932 -19.0169 -149.741C103.531 -272.288 249.368 -325.14 306.72 -267.788C364.072 -210.436 199.403 -160.471 76.8557 -37.9238Z",
    fill: "#52B6FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_f_2300_106344)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.4677,
    cy: -257.315,
    r: 171.765,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 345.957,
    y: 10.0305,
    width: 402.319,
    height: 402.319,
    rx: 201.16,
    transform: "rotate(90 345.957 10.0305)",
    fill: "url(#paint0_linear_2300_106344)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.796,
    y: 10.1912,
    width: 401.998,
    height: 401.998,
    rx: 200.999,
    transform: "rotate(90 345.796 10.1912)",
    stroke: "url(#paint1_linear_2300_106344)",
    strokeOpacity: 0.6,
    strokeWidth: 0.321326
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.926,
    y: 100.059,
    width: 222.262,
    height: 222.262,
    rx: 111.131,
    transform: "rotate(90 255.926 100.059)",
    fill: "url(#paint2_linear_2300_106344)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.765,
    y: 100.22,
    width: 221.941,
    height: 221.941,
    rx: 110.971,
    transform: "rotate(90 255.765 100.22)",
    stroke: "url(#paint3_linear_2300_106344)",
    strokeOpacity: 0.6,
    strokeWidth: 0.321326
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2300_106344",
    x: -123.756,
    y: -383.897,
    width: 928.661,
    height: 929.586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.464,
    result: "effect1_foregroundBlur_2300_106344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2300_106344",
    x: -385.147,
    y: -515.872,
    width: 928.552,
    height: 929.481,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.464,
    result: "effect1_foregroundBlur_2300_106344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2300_106344",
    x: -286.827,
    y: -557.61,
    width: 600.588,
    height: 600.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.2652,
    result: "effect1_foregroundBlur_2300_106344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2300_106344",
    x1: 329.821,
    y1: 175.847,
    x2: 623.159,
    y2: 329.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2300_106344",
    x1: 337.448,
    y1: 145.797,
    x2: 463.238,
    y2: 329.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2300_106344",
    x1: 247.011,
    y1: 191.665,
    x2: 409.067,
    y2: 276.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2300_106344",
    x1: 251.225,
    y1: 175.063,
    x2: 320.718,
    y2: 276.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.5e7cb10b3c27ef9194603016a708abde.svg";
export { ForwardRef as ReactComponent };